import { render, staticRenderFns } from "./c_home_pink.vue?vue&type=template&id=5c7ca6e0&scoped=true&"
import script from "./c_home_pink.vue?vue&type=script&lang=js&"
export * from "./c_home_pink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7ca6e0",
  null
  
)

export default component.exports